import { render, staticRenderFns } from "./winnerdialog.vue?vue&type=template&id=d21bbd7a"
import script from "./winnerdialog.vue?vue&type=script&lang=js"
export * from "./winnerdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports